
export const clientVersion = "0.2.0";

export const clientInfoVersion = "0.2.0-mvp.5+Branch.0.2.0-mvp5.Sha.7449b5cc058f42c4f23fc14cea925a41476e95df";

